
import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-toggle-element-attributes]';
export const PLUGIN_NAME = 'ToggleElementAttributes';

$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--toggle-element-attributes" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__toggle-element-attributes/index.js